import { yupResolver } from '@hookform/resolvers/yup'
import ContactMailIcon from '@mui/icons-material/ContactMail'
import LoginIcon from '@mui/icons-material/Login'
import PasswordIcon from '@mui/icons-material/Password'
import { LoadingButton } from '@mui/lab'
import {
  Container,
  InputAdornment,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import { useAppDispatch } from 'app/hooks'
import { UIAction } from 'app/slices/UI'
import { AxiosClientError } from 'interface'
import { useSnackbar } from 'notistack'
import { useState } from 'react'
import { SubmitHandler, useForm } from 'react-hook-form'
import axiosClient from 'utils/axiosClient'
import * as yup from 'yup'

interface FormInput {
  id: string
  password: string
}
const schema = yup.object({
  id: yup.string().required(),
  password: yup.string().required(),
})
export default function Login() {
  const { enqueueSnackbar } = useSnackbar()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormInput>({
    resolver: yupResolver(schema),
    defaultValues: {
      id: '',
      password: '',
    },
  })

  const onSubmit: SubmitHandler<FormInput> = async (data) => {
    const { id, password } = data
    try {
      setLoading(true)
      const { data } = await axiosClient.post('/auth/organizer/login', {
        id,
        password,
      })
      dispatch(UIAction.setAuth(data))
    } catch (error) {
      const { status } = error as AxiosClientError
      const msg = 'ログインできませんでした。'

      enqueueSnackbar(msg, {
        variant: 'error',
      })
      status === 423 &&
        dispatch(
          UIAction.setNotice(
            'アカウントをロックしました。しばらくたってからログインしてください。'
          )
        )
    } finally {
      setLoading(false)
    }
  }
  return (
    <Container
      maxWidth="xs"
      disableGutters
      component="form"
      noValidate
      autoComplete="off"
      onSubmit={handleSubmit(onSubmit)}
    >
      <Typography mt={4} align="center" variant="h4" component="h2">
        ログイン
      </Typography>
      <TextField
        autoFocus
        required
        margin="dense"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <ContactMailIcon color="primary" />
            </InputAdornment>
          ),
        }}
        label="ID"
        fullWidth
        variant="standard"
        {...register('id')}
        error={'id' in errors}
      />

      <TextField
        required
        margin="dense"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <PasswordIcon color="primary" />
            </InputAdornment>
          ),
        }}
        label="パスワード"
        autoComplete="on"
        type="password"
        fullWidth
        variant="standard"
        {...register('password')}
        error={'password' in errors}
      />
      <Stack justifyContent="center" direction="row">
        <LoadingButton
          disabled={Object.keys(errors).length > 0}
          variant="contained"
          type="submit"
          sx={{
            mt: 4,
            px: 4,
          }}
          loading={loading}
          color={'primary'}
          loadingPosition="start"
          startIcon={<LoginIcon />}
        >
          ログイン
        </LoadingButton>
      </Stack>
    </Container>
  )
}
